// Tryb — API client.
//
// Every call returns parsed JSON and throws an ApiError carrying the server's
// own message, so the UI can show what the API actually said rather than a
// generic failure.

export class ApiError extends Error {
  constructor(status, body) {
    super(body?.error || `Request failed (${status})`);
    this.name = "ApiError";
    this.status = status;
    this.hint = body?.hint;
    this.errors = body?.errors || body?.rejected || null;
    this.body = body;
  }
}

async function request(method, path, { body, form } = {}) {
  const init = { method, headers: {} };

  if (form) init.body = form;
  else if (body !== undefined) {
    init.headers["Content-Type"] = "application/json";
    init.body = JSON.stringify(body);
  }

  const res = await fetch(`/api${path}`, init);
  const text = await res.text();
  const json = text ? JSON.parse(text) : {};

  if (!res.ok) throw new ApiError(res.status, json);
  return json;
}

export const api = {
  // ---- sign in ----
  authConfig: () => request("GET", "/auth/config"),
  me: () => request("GET", "/auth/me"),
  requestOtp: (phone) => request("POST", "/auth/otp/request", { body: { phone } }),
  verifyOtp: (phone, code) => request("POST", "/auth/otp/verify", { body: { phone, code } }),
  verifyWidgetToken: (token, phone) => request("POST", "/auth/widget/verify", { body: { token, phone } }),
  logout: () => request("POST", "/auth/logout"),

  studio: () => request("GET", "/studio"),

  saveAnswers: (patch) => request("PATCH", "/answers", { body: { patch } }),

  advanceOnboarding: (step) => request("POST", "/onboarding/advance", { body: { step } }),
  goToOnboardingStep: (step) => request("POST", "/onboarding/step", { body: { step } }),
  completeOnboarding: () => request("POST", "/onboarding/complete"),

  checkWizardStep: (step, mode) => request("POST", "/wizard/check", { body: { step, mode } }),
  publishListing: () => request("POST", "/trybs/publish"),
  saveVenue: () => request("POST", "/venues"),
  publishReup: () => request("POST", "/trybs/reup"),


  uploadDocument: (fieldId, file) => {
    const form = new FormData();
    form.append("file", file);
    return request("POST", `/documents/${encodeURIComponent(fieldId)}`, { form });
  },
  deleteDocument: (fieldId) => request("DELETE", `/documents/${encodeURIComponent(fieldId)}`),


  // ---- Canva Connect ----
  canvaStatus: () => request("GET", "/canva/status"),
  canvaDisconnect: () => request("POST", "/canva/disconnect"),
  canvaDesigns: (q) => request("GET", `/canva/designs${q ? `?q=${encodeURIComponent(q)}` : ""}`),
  canvaBrandTemplates: (q) => request("GET", `/canva/brand-templates${q ? `?q=${encodeURIComponent(q)}` : ""}`),
  canvaCreateDesign: (title) => request("POST", "/canva/designs", { body: { title } }),
  canvaUseBrandTemplate: (id, title, fields) =>
    request("POST", `/canva/brand-templates/${encodeURIComponent(id)}/use`, { body: { title, fields } }),
  canvaUseAsCover: (designId, title) =>
    request("POST", `/canva/designs/${encodeURIComponent(designId)}/use-as-cover`, { body: { title } }),
};
